// Only classify explicitly written specifications; model codes and blower speeds
// do not establish efficiency or heating/compressor stages.
export function equipmentPerformance(type: string, text: string) {
  const rating = text.match(/\b\d+(?:\.\d+)?\s*(?:SEER2?|EER2?|HSPF2?|UEF)\b/i)?.[0];
  const percentage = /furnace|boiler/i.test(type) ? text.match(/\b\d{2}(?:\.\d+)?\s*%/)?.[0] : null;
  const efficiency = percentage?.replace(/\s/g, "") || rating?.toUpperCase() || "Efficiency to confirm";
  const stages = new Set<string>();
  if (/\b(?:single|one|1)[ -]*stage\b/i.test(text)) stages.add("Single-stage");
  if (/\b(?:two|2)[ -]*stage\b/i.test(text)) stages.add("Two-stage");
  if (/\bmodulating\b/i.test(text)) stages.add("Modulating");
  if (/condenser|heat pump/i.test(type) && !/blower|air handler/i.test(type + " " + text)) {
    if (/\bvariable[ -]speed\b/i.test(text)) stages.add("Variable-speed");
    else if (/\binverter\b/i.test(text)) stages.add("Inverter");
  }
  return { efficiency, stage: stages.size === 1 ? [...stages][0] : "Stages to confirm" };
}

export function equipmentSeriesAndCapacity(text: string) {
  const seriesMatches = [...new Set(text.match(/\b(?:Comfort|Performance|Infinity)\b/gi)?.map((value) => value.toLowerCase()) ?? [])];
  const series = seriesMatches.length === 1 ? seriesMatches[0][0].toUpperCase() + seriesMatches[0].slice(1) : "Series to confirm";
  const tons = text.match(/\b(\d+(?:\.\d+)?|\d+\/\d+)\s*[- ]?tons?\b/i)?.[1];
  const value = tons?.includes("/") ? Number(tons.split("/")[0]) / Number(tons.split("/")[1]) : Number(tons);
  return { series, capacity: value > 0 && value <= 20 ? `${value} ton` : "Tonnage to confirm" };
}
